import { Role } from '../../types/type';

export interface ICreateUserForm {
  login: string;
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  phoneNumber: string;
  // '' — роль ещё не выбрана
  role: Role | '';
  status: string;
  autoparkID?: string;
  isInternal: boolean;
}

// Форма прошла проверку: роль выбрана
export type IValidCreateUserForm = ICreateUserForm & { role: Role };

// Медик и техник бывают «нашими» или из автопарка
export function hasInternalChoice(role: Role | ''): boolean {
  return role === 'medic' || role === 'technik';
}

// Пустой ID ("") бэкенд отклоняет; «наш» сотрудник к автопарку не привязан
function sendsAutoparkID({ autoparkID, isInternal, role }: IValidCreateUserForm): boolean {
  if (!autoparkID) return false;
  return !(isInternal && (hasInternalChoice(role) || role === 'admin'));
}

// Тело POST /profiles из формы создания пользователя
export function buildCreateUserPayload(user: IValidCreateUserForm) {
  const { autoparkID, ...fields } = user;
  return {
    ...fields,
    // Отчество — отдельное необязательное поле, пустое не отправляем
    middleName: user.middleName.trim() || undefined,
    // Водитель всегда создаётся неактивным: активирует его только регистрация
    status: user.role !== 'driver' && user.status === 'active',
    ...(sendsAutoparkID(user) ? { autoparkID } : {}),
  };
}
